import { z } from 'zod';

/**
 * Zod schema for a single alert entry from GET /api/popup-alerts.
 * @see app/src/Controller/Api/PopupAlert/GetActiveAlertsAction.php::toAlertPayload()
 */
export const PopupAlertSchema = z.object({
    id: z.number(),
    title: z.string(),
    message: z.string(),
    link: z.string(),
    linkText: z.string().nullable(),
    timeSince: z.string(),
    forceDistrictRedirect: z.boolean(),
});

/**
 * Zod schema for the top-level GET /api/popup-alerts response.
 * @see app/src/Controller/Api/PopupAlert/GetActiveAlertsAction.php::toPayload()
 */
export const PopupAlertsResponseSchema = z.object({
    alerts: z.array(PopupAlertSchema),
    districtUrl: z.string().nullable(),
});

export type PopupAlert = z.infer<typeof PopupAlertSchema>;
export type PopupAlertsResponse = z.infer<typeof PopupAlertsResponseSchema>;
